import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'react-bootstrap';
const uuid = require('uuid');

const AdminAnalyticsStore = require('../../stores/AdminAnalyticsStore');
const AdminAnalyticsActions = require('../../actions/AdminAnalyticsActions');
import SortableTableClassic from '../table/SortableTableClassic';
import AnalyticsRawDataBlock from './AnalyticsRawDataBlock';
import JsonTextArea from '../common/JsonTextArea';
import ErrorBox from '../common/ErrorBox';
import WarningBox from '../common/WarningBox';

const propTypes = {};
const defaultProps = {};

class AdminAnalyticsErrorsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            adminAnalyticsStoreState: AdminAnalyticsStore.getState(),
            selectedRawDataActInstId: null,
            newTokenName: "",
            newTokenDescription: "",
            retryAnalyticsActionId: null,
            retryError: null
        }

        this.onRawDataClick = this.onRawDataClick.bind(this);
        this.refreshActInstAnalytics = this.refreshActInstAnalytics.bind(this);
        this.retryActInstAnaltyics = this.retryActInstAnaltyics.bind(this);
        this.unsubscribes = [AdminAnalyticsStore.listen(this.onAnalyticsStoreChange.bind(this))];
    }

    UNSAFE_componentWillMount() {
        AdminAnalyticsActions.getAdminActInstRawDataWithError(uuid.v4());
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onAnalyticsStoreChange(state) {
        let additionalState = {};

        if (state.action.id === this.state.retryAnalyticsActionId) {
            additionalState = { ...additionalState, retryAnalyticsActionId: null };
            if (state.action.error) {
                additionalState = { ...additionalState, retryError: state.action.error };
            }
        }


        this.setState({ adminAnalyticsStoreState: state, ...additionalState });
    }

    onRawDataClick(e, rawDataActInstId) {
        this.setState({ selectedRawDataActInstId: rawDataActInstId, retryError: null });
    }

    refreshActInstAnalytics() {
        if (!this.state.selectedRawDataActInstId) {
            return;
        }

        AdminAnalyticsActions.getAdminActInstAnalytics(uuid.v4(), { novaActInstId: this.state.selectedRawDataActInstId });
    }

    retryActInstAnaltyics() {
        if (!this.state.selectedRawDataActInstId) {
            console.log('returning...');
            return;
        }

        const retryAnalyticsId = uuid.v4();
        this.setState({ retryAnalyticsActionId: retryAnalyticsId },
            AdminAnalyticsActions.retryAdminActInstAnalytics(retryAnalyticsId, { novaActInstId: this.state.selectedRawDataActInstId }));
    }

    render() {
        if (!this.state.adminAnalyticsStoreState) {
            return null;
        }

        let selectedRawDataRecord = null;
        if (this.state.selectedRawDataActInstId) {
            selectedRawDataRecord = this.state.adminAnalyticsStoreState.adminActInstRawDataWithError.find(rd => { return rd.nova_act_inst_id === this.state.selectedRawDataActInstId; });
        }

        return (
            <div>
                <ErrorBox error={this.state.adminAnalyticsStoreState.action.error} />

                <SortableTableClassic
                    key="raw-data-table"
                    title="Analytics Raw Data (Error State)"
                    uniqueRowKey="nova_act_inst_id"
                    onRowClick={this.onRawDataClick}
                    rows={this.state.adminAnalyticsStoreState.adminActInstRawDataWithError}
                    selectedRowKey={this.state.selectedRawDataActInstId}
                    columns={
                        [
                            {
                                displayName: 'ID',
                                key:'id',
                                size: 1,
                                type: 'int'
                            },
                            {
                                displayName: 'NovaActInstId',
                                key:'nova_act_inst_id',
                                size: 2,
                                type: 'string'
                            },
                            {
                                displayName: 'Error',
                                key:'error',
                                size: 1,
                                type: 'bool'
                            },
                            {
                                displayName: 'Create Date',
                                key:'created_at',
                                size: 2,
                                type: 'date'
                            }
                        ]
                    }
                />

                {(selectedRawDataRecord) &&
                    <div>
                        <h3 className="view-title margin-top-lg">Analytics Raw Data (Forge DB record)</h3>
                        <AnalyticsRawDataBlock analyticsRawData={selectedRawDataRecord} />
                        <h3 className="view-title margin-top-lg">View Existing Act. Inst. Analytics from Template Server</h3>
                        <Card body bg="light">
                            <div className="margin-bottom-md">
                                <Button onClick={this.refreshActInstAnalytics}>Refresh</Button>
                            </div>
                            <JsonTextArea
                                className="width-100p"
                                readOnly
                                json={this.state.adminAnalyticsStoreState.adminActInstAnalytics[this.state.selectedRawDataActInstId]}
                            />
                        </Card>
                        <h3 className="view-title margin-top-lg">Update Record w/ Existing Act. Inst. Analytics from Template Server</h3>
                        <Card body bg="light">
                            <WarningBox>
                                {`Attempts to automatically repair analytics data by discarding existing activity instance analytics records,
                                    re-fetching data from template server and re-processing. Note: Will not update Analytics Raw Data record
                                    with new error if one is encountered during re-processing.`}
                            </WarningBox>
                            <ErrorBox allowStackTrace error={this.state.retryError} />
                            <Button
                                variant="danger"
                                disabled={!!this.state.retryAnalyticsActionId || !selectedRawDataRecord.error}
                                onClick={this.retryActInstAnaltyics}
                            >
                                Retry analytics records generation with new template data
                            </Button>
                        </Card>
                    </div>
                }
            </div>
        );
    }
}

AdminAnalyticsErrorsView.propTypes = propTypes;
AdminAnalyticsErrorsView.defaultProps = defaultProps;

export default AdminAnalyticsErrorsView;